let downloadClickListenerAdded = false;

export function downloadOnClick() {
    if (downloadClickListenerAdded) return; // Prevent multiple listeners

    document.addEventListener("click", async function (e) {
        const btn = e.target.closest(".download-acf-zip");
        if (!btn) return;

        e.preventDefault();

        const buttontext = btn.textContent;
        const preparingText = btn.getAttribute("data-preparing") || "Preparing...";
        const postId = btn.dataset.postId;

        btn.disabled = true;
        btn.textContent = preparingText;

        try {
            const res = await fetch(nlTheme.ajaxurl, {
                method: "POST",
                body: new URLSearchParams({
                    action: "download_acf_images_zip_ajax",
                    post_id: postId,
                }),
            });

            const data = await res.json();

            if (data.success && data.data.url) {
                const response = await fetch(data.data.url);
                const blob = await response.blob();
                const blobUrl = window.URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = blobUrl;
                link.download = data.data.url.split("/").pop();
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
            } else {
                // Optionally show error
                // alert(data.message || "Something went wrong.");
            }
        } catch (err) {
            alert("AJAX failed.");
        } finally {
            btn.disabled = false;
            btn.textContent = buttontext;
        }
    });

    downloadClickListenerAdded = true;
}

export function initDownloadModal() {
    const downloadLinks = document.querySelectorAll('.download-link');
    const modal = document.querySelector('.download-modal-overlay');
    
    // We allow finding links even if modal is not present (though modal is needed for the gate)
    // But if modal is missing, we can't show it. So check for modal.
    if (!downloadLinks.length || !modal) return;

    const closeBtn = modal.querySelector('.modal-close-download');
    let currentFileId = '';

    // Helper to trigger download
    async function triggerDownload(fileId) {
        if (!fileId) return;
        
        try {
            const formData = new FormData();
            formData.append('action', 'get_download_url_ajax');
            formData.append('attachment_id', fileId);

            const response = await fetch(nlTheme.ajaxurl, {
                method: 'POST',
                body: formData
            });

            const result = await response.json();

            if (result.success && result.data.url) {
                 const a = document.createElement('a');
                 a.href = result.data.url;
                 a.setAttribute('download', '');
                 document.body.appendChild(a);
                 a.click();
                 document.body.removeChild(a);
            } else {
                console.error('Download failed:', result);
                alert('Download link verification failed.');
            }

        } catch (error) {
            console.error('Download error:', error);
        }
    }

    // Open Modal or Download directly
    downloadLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const fileId = link.getAttribute('data-file-id');
            if (!fileId) return;

            const hasSubmitted = localStorage.getItem('downloadFormSubmitted');
            
            if (hasSubmitted === 'true') {
                // Already submitted, just download
                triggerDownload(fileId);
            } else {
                // Need to submit form
                currentFileId = fileId;
                modal.classList.add('active');
            }
        });
    });

    // Close Modal
    function closeModal() {
        modal.classList.remove('active');
        currentFileId = '';
    }

    if (closeBtn) {
        closeBtn.addEventListener('click', closeModal);
    }
    
    modal.addEventListener('click', (e) => {
        if (e.target === modal) closeModal();
    });

    // Handle Form Submission Success
    document.addEventListener('wpcf7mailsent', function(event) {
        // If modal is active, that means this submission came from our download gate
        
        if (modal.classList.contains('active')) {
             // Mark as submitted
             localStorage.setItem('downloadFormSubmitted', 'true');
             
             if (currentFileId) {
                triggerDownload(currentFileId);
                
                // Close modal after a short delay
                setTimeout(() => {
                    closeModal();
                }, 2000);
             }
        }
    }, false); 
}